import {Controller} from '@hotwired/stimulus';
import {messenger} from 'app/utils/messenger';
import {ERROR_COPY_TO_CLIPBOARD, SUCCESS_COPY_TO_CLIPBOARD, trans} from 'app/translator';

export default class CopyToClipboardController extends Controller
{
    declare private valueValue: string;
    declare private hasValueValue: boolean;

    static values = {
        value: String,
    };

    async copy() {
        if (!this.hasValueValue) {
            return;
        }
        try {
            await navigator.clipboard.writeText(this.valueValue);
            messenger.success(trans(SUCCESS_COPY_TO_CLIPBOARD));
        } catch (error) {
            console.error(error);
            messenger.error(trans(ERROR_COPY_TO_CLIPBOARD));
        }
    }
}
